module.exports = __webpack_public_path__ + "static/images/callout_1.96410ccc045d64eb6049937fac3a5c30.jpg";